/* eslint-disable guard-for-in */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { AlertController, IonModal, LoadingController, ModalController, NavController, Platform } from '@ionic/angular';
import { ApiService } from 'src/app/providers/apiService/api.service';
import * as moment from 'moment';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { StorageService } from 'src/app/providers/storageService/storage.service';
import { ToastService } from 'src/app/providers/toastService/toast.service';
import { DoctorsListComponent } from '../../components/doctors-list/doctors-list.component';
import { ImagingService } from 'src/app/providers/files/imaging.service';
import { EventsService } from 'src/app/providers/events/events.service';
import { environment } from 'src/environments/environment';
import { createWorker, PSM, OEM } from 'tesseract.js';
import { Capacitor } from '@capacitor/core';
import {
  ImageCroppedEvent,
  ImageCropperComponent,
  ImageTransform,
} from 'ngx-image-cropper';
import { DomSanitizer } from '@angular/platform-browser';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';

@Component({
  selector: 'app-advanced',
  templateUrl: './advanced.page.html',
  styleUrls: ['./advanced.page.scss'],
})
export class AdvancedPage {
  
  @ViewChild('cropper') cropper: ImageCropperComponent;
  labelType: number;
  myImage: any = null;
  croppedImage: any = '';
  transform: ImageTransform = {};
  isMobile = Capacitor.getPlatform() !== 'web';
  @ViewChild(IonModal) modal: IonModal;

  isCropperModalOpen = false;
  isPhotoPromptModalOpen = false;
  isModalOCRDetailOpen = false;
  ocrResults = '';

  message = 'This modal example uses triggers to automatically open a modal when the button is clicked.';
  name: string;
  advancedForm: FormGroup;
  imageUrl: string;
  hospitalList: any[] = [];
  user: any;
  unreadCount: any;
  doctorList: any;
  submitted = false;
  minDate = moment().format();
  date: string;
  doctorRole = '';
  imgBaseUrl = environment.imgBaseUrl;
  existingPatient: any;
  loading = false;
  title = "Advanced";
  patient_dateofbirth: any;
  patient_referraldate: any;
  imageChangedEvent: any = '';
  errorMessages = {
    patient_first_name: [{ type: 'required', message: ' Enter First Name.' }],
    patient_last_name: [{ type: 'required', message: ' Enter Last Name.' }],
    patient_date_of_birth: [{ type: 'required', message: ' Choose Date Of Birth' }],
    referral_date: [{ type: 'required', message: ' Choose Referral Date' }],
  };

  patientlabelname: string;
  capture_firstname: number;	
  capture_lastname: number;
  name_row: number;
  name_order: number;
  capture_dob: number;
  dob_format: string;
  dob_prefix_1: string;
  dob_prefix_2: string;
  dob_suffix: string;
  capture_mc: number;
  mc_prefix: string;
  thisVersion:string;
  userPlatform:any;

  constructor(
    private platform: Platform,
    public formBuilder: FormBuilder,
    public storageService: StorageService,
    private apiService: ApiService,
    public route: ActivatedRoute,
    public router: Router,
    public navCtrl: NavController,
    public toastService: ToastService,
    public alertController: AlertController,
    public modalController: ModalController,
    public events: EventsService,
    private loadingCtrl: LoadingController,
    private sanitizer: DomSanitizer,
    private appVersion: AppVersion, 

  ) {
    platform.ready().then(() => {
      this.userPlatform = this.platform;
    });

    this.appVersion.getVersionNumber().then((res)=>{
      this.thisVersion = res;
    });

    this.advancedForm = this.formBuilder.group({
      patient_first_name: ['', Validators.required],
      patient_last_name: ['', Validators.required],
      patient_date_of_birth: [moment().format(), Validators.required],
      hospital: [''],
      admission_status: [0],
      patient_status: [0],
      referral_date: [moment().format(), Validators.required],
      ref_doctorF: [''],
      ref_doctorL: [''],
      ref_doctor: [''],
      images: [[]],
      ward: [''],
      editing: [''],
      ispatient: [true],  //this is NOT a billing submission, it is a patient addition or update
      type: ['advanced'],
      User: [''],
      ward_status: [false],
      billType: [''],
      comments: [''],
      version: this.thisVersion, 
      platform: this.userPlatform,
    });
        this.patient_dateofbirth = moment().format();
        this.patient_referraldate = moment().format();

    this.events.subscribe('PatientInfoEvent', (data: any) => {
      if (data) {
        this.existingPatient = data;
        console.log('Data: ',data);
        this.advancedForm.patchValue(this.existingPatient.Data);
        if (this.existingPatient?.Page[0]?.filename) {
          let imageUrlExisting = this.imgBaseUrl + this.existingPatient?.Page[0]?.filename;
          this.imageUrl = imageUrlExisting;
        }
        this.advancedForm.controls.editing.setValue(this.existingPatient.Data.id);
        this.advancedForm.controls.ward_status.setValue(this.existingPatient.Data.ward_status == '1' ? true : false);
        this.patient_dateofbirth = this.existingPatient.Data.patient_date_of_birth;
        this.patient_referraldate = this.existingPatient.Data.referral_date;

        var refF = this.existingPatient.Data.referring_provider.split(" ")[0];
        this.advancedForm.controls.ref_doctorF.setValue(refF);
        this.advancedForm.controls.ref_doctorL.setValue(this.existingPatient.Data.referring_provider.replace(refF + " ",""));
      
      }
      //console.log(this.patient_dateofbirth);
    }); 

    

  }


  ionViewWillEnter() {
   //console.log(this.route.pathFromRoot);
   this.getLabelType();
    this.getnotificationCount();
    this.getHospitalList();
    this.storageService.get('doctor_role').then(res => {
      this.doctorRole = res;
    });
    //console.log(this.user);
    this.storageService.get('state').then(res => {
      if (res == "patient")
      {
        this.advancedForm.controls.ispatient.setValue(true);
        this.title = "Add Patient";
        if (this.existingPatient)
        {
          this.title = "Edit Patient";
        }
      }
      else if (res == "ward-round")
      {
        this.title = "Add Ward Round Patient";
        if (this.existingPatient)
        {
          this.title = "Edit Ward Round Patient";
        }
        this.advancedForm.controls.ward_status.setValue(true);
      }
    });

    
    //console.log('1capture_dob: ',this.capture_dob);
  }
  async getLabelType()
  {
    this.labelType = null;
    await this.apiService
      .post('user-label-type', {})
      .subscribe(
        (res) => {
          //console.log( 'res.. ',res);
          if (res.error === false) {
            this.labelType = res.patientlabel;
            this.getPatientLabelConfig();
          }
        },
        (err) => { }
      );
  }
  
  async getPatientLabelConfig()
  {    

    if (this.labelType != 0)
    {
      const params = {
      patientlabel: this.labelType
      };
        this.apiService
        .post('data/patient-label-config', params)
        .subscribe(
        (res) => {
          if (res.error === false) {
            //console.log('Label Config: ', res);
            this.patientlabelname = res.data.PatientLabels.patientlabel_name;
            this.capture_firstname = res.data.PatientLabels.capture_firstname;
            this.capture_lastname = res.data.PatientLabels.capture_lastname;
            this.name_row = res.data.PatientLabels.name_row;
            this.name_order = res.data.PatientLabels.name_order;
            this.capture_dob = res.data.PatientLabels.capture_dob;
            this.dob_prefix_1 = res.data.PatientLabels.dob_prefix_1;
            this.dob_prefix_2 = res.data.PatientLabels.dob_prefix_2;
            this.dob_suffix = res.data.PatientLabels.dob_suffix;
            this.capture_mc = res.data.PatientLabels.capture_mc;
            this.mc_prefix = res.data.PatientLabels.mc_prefix;
            this.dob_format = res.data.PatientLabels.dob_format;
            //console.log('2capture_dob: ',this.capture_dob);
          }
        },
        (err) => { }
        );
    }
    else
    {
      this.patientlabelname = 'Default';
      this.capture_firstname = 1;
      this.capture_lastname = 1;
      this.name_row = 1;
      this.name_order = 1;
      this.capture_dob = 1;
      this.dob_prefix_1 = 'DOB:';
      this.dob_prefix_2 = '';
      this.dob_suffix = '';
      this.capture_mc = 1;
      this.mc_prefix = 'MC:';
    }
  }
  
  async ocrPatient(image:string)
  {
     
    var ocrRecords = [];
    var oktogo = false;
    var results:string;
       try {
         if (image)
         {
           
          const recognizedText = await this.recognizeTextFromImage(image);
           
          //console.log('recognised: ',recognizedText);

           // Assuming the recognized text contains the name and date of birth in a specific format,
           // you can extract the name and date of birth using regular expressions or string manipulation.
           const regexName = /([A-Za-z\s'-]+),\s((?:MR|MRS|MS|MISS|Mr|Mrs|Ms|Miss)\s)([A-Za-z\s'-]+)(?:\s([A-Za-z\s'-]+(?=,|$)))?(?=\n|\s|$)/;
           const regexNameType2 = /((?:MR|MRS|MS|Mr|Mrs|Ms|Miss)\s)?([A-Za-z\s'-]+)(?:\s([A-Za-z\s'-]+))?\s([A-Za-z\s'-]+)\s/;
           var matchName:any;
           
           var lastname = '';
           var title = '';
           var firstname = '';
           var otherNames = '';
    

           results =  "labeltype: "+this.labelType+", name_row: "+this.name_row;
           //console.log('name_row: ',this.name_row);
           if (this.name_row > 1)
           {
              var rows_raw = recognizedText.split("\n");
              var rows = new Array();
              //remove empty rows
              {
                rows_raw.forEach(checkrow => {
                  if (checkrow.length > 0)
                  {
                    rows.push(checkrow);
                  }
                  
                });
              }
              var preMatchName = rows[this.name_row-1];
              if (this.name_order == 1)
              {
                matchName = preMatchName.match(regexName);      
                //console.log('Match Name: ', matchName); 
                lastname = matchName ? this.toNameCase(matchName[1]) : '';
                title = matchName && matchName[2] ? this.toNameCase(matchName[2].trim()) : ''; // Extract title from first part
                firstname = matchName ? this.toNameCase(matchName[3]) : ''; // Extract first name from second part
                if (firstname.includes(' '))
                {
                  firstname = firstname.split(' ')[0];
                  otherNames = firstname.split(' ')[1];
                }
                else
                {
                  otherNames = matchName && matchName[4] ? this.toNameCase(matchName[4].trim()) : ''; // Extract other names if present       
                }
              }
              if (this.name_order == 2)
              {
                matchName = preMatchName.match(regexNameType2);
                //console.log('Match Name: ', matchName);
                lastname = matchName ? this.toNameCase(matchName[4]) : '';
                title = matchName && matchName[1] ? this.toNameCase(matchName[1].trim()) : ''; // Extract title from first part
                firstname = matchName ? this.toNameCase(matchName[2]) : ''; // Extract first name from second part
                if (firstname.includes(' '))
                {
                  firstname = firstname.split(' ')[0];
                  otherNames = firstname.split(' ')[1];
                }
                else
                {
                  otherNames = matchName && matchName[4] ? this.toNameCase(matchName[4].trim()) : ''; // Extract other names if present       
                }
              }
              
           }
           else
           {
              matchName = recognizedText.match(regexName);
              //console.log('Match Name: ', matchName);
              lastname = matchName ? this.toNameCase(matchName[1]) : '';
              title = matchName && matchName[2] ? this.toNameCase(matchName[2].trim()) : ''; // Extract title from first part
              firstname = matchName ? this.toNameCase(matchName[3]) : ''; // Extract first name from second part
              //console.log('Found First before namecase: ', matchName[3]);
              //console.log('Found First: ', firstname);
              if (firstname.includes(' '))
              {
                otherNames = firstname.split(' ')[1];
                firstname = firstname.split(' ')[0];
                //console.log('FirstName split: ', firstname);
                //console.log('OtherName split: ', otherNames);
              }
              else
              {
                otherNames = matchName && matchName[4] ? this.toNameCase(matchName[4].trim()) : ''; // Extract other names if present       
              }
              results=results+"...name:"+firstname+".."+lastname+".."+otherNames;
                
           } 
           //console.log('name: ', matchName);
          results += ' MatchName: '+matchName+' ... ';
           
    

           /* const name = matchName ? `${this.toNameCase(matchName[1])} ${this.toNameCase(matchName[3])}` : '';
           var firstname:string = matchName ? this.toNameCase(matchName[3]):'';
           firstname = firstname.replace("\n",""); //remove additional return characters
           const title = matchName ? this.toNameCase(matchName[2]):'';
           const lastname = matchName ? this.toNameCase(matchName[1]):''; */
 
           const regexMC = /MC:\s?(\d+\/?\d*)\s/;
           const regexMedicare = /Medicare:\s?(\d+\/?\d*)\s/;
           var matchMC = recognizedText.match(regexMC);
           if (!matchMC)
           {
             matchMC = recognizedText.match(regexMedicare);
           }
           var Medicare:string = matchMC ? matchMC[1] : '';
           //console.log('regexdob1: ',this.dob_prefix_1);
           //console.log('regexdob2: ',this.dob_prefix_2);
          var regexDOB1: RegExp;
          var regexDOB2: RegExp;
          var matchDOB1: RegExpMatchArray;
          var matchDOB2: RegExpMatchArray;
          var yeardigits = 4;
          var matchDate:string[];
          var day:string;
          var month:string;
          var year:string;
          var dob: string;
          var separator = '/';
          if(this.dob_format == null)
          {
            this.dob_format = 'dd/MM/yyyy'; //default
          }
          if (this.dob_format.indexOf('-')>= 0)
          {
            separator = '-';
          }
          switch (this.dob_format)
          {
            case 'dd/MM/yyyy': 
            case 'dd-MM-yyyy':
            case 'dd/MM/yy':
            case 'dd-MM-yy':
            default:
              if (this.dob_format.endsWith('/yy') || this.dob_format.endsWith('-yy'))
              {
                yeardigits = 2;
              }
              regexDOB1 = RegExp('('+this.dob_prefix_1+')(\\s+)(\\d\\d)(-|\\/)(\\d\\d)(-|\\/)(\\d{1,4})'); 
              regexDOB2 = RegExp('('+this.dob_prefix_2+')(\\s+)(\\d\\d)(-|\\/)(\\d\\d)(-|\\/)(\\d{1,4})'); 
              matchDOB1 = recognizedText.match(regexDOB1);
              matchDOB2 = recognizedText.match(regexDOB2);
              if (matchDOB1 != null) 
              {
                var matchDOB1str:string = matchDOB1.toString().replace(this.dob_prefix_1,'').replace(/\s/g,'').split(',')[0];
                //console.log('regexdob1: ',regexDOB1, ', match: ',matchDOB1str.toString());
                var matchDate = matchDOB1str.split(separator);
                var day = matchDate[0];
                var month = matchDate[1];
                var year = matchDate[2];
                if (yeardigits == 2)
                {
                  year = '19'+year;
                }
              }          
              else if (matchDOB2 != null) 
                {
                  var matchDOB2str:string = matchDOB2.toString().replace(this.dob_prefix_2,'').replace(/\s/g,'').split(',')[0];
                  //console.log('regexdob2: ',regexDOB2, ', match: ',matchDOB2str.toString());
                  var matchDate = matchDOB2str.split(separator);
                  var day = matchDate[0];
                  var month = matchDate[1];
                  var year = matchDate[2];
                  if (yeardigits == 2 && year.startsWith('0'))
                  {
                    year = '20'+year;
                  }
                  else
                  {
                    year = '19'+year;
                  }
                }              
              break;
            case 'yyyyMMdd':
              regexDOB1 = RegExp(`${this.dob_prefix_1}(\\s+)((\\d{7})`); 
              regexDOB2 = RegExp(`${this.dob_prefix_2}(\\s+)((\\d{7})`); 
              matchDOB1 = recognizedText.match(regexDOB1);
              matchDOB2 = recognizedText.match(regexDOB2);
              if (matchDOB1 != null) 
              {
                var matchDOB1str:string = matchDOB1.toString().replace(this.dob_prefix_1,'').replace(/\s/g,'').split(',')[0];
                
                var day = matchDOB1str.substring(6,7);
                var month = matchDOB1str.substring(4,5);
                var year = matchDOB1str.substring(0,3);
              }          
              if (matchDOB2 != null) 
                {
                  var matchDOB2str:string = matchDOB2.toString().replace(this.dob_prefix_2,'').replace(/\s/g,'').split(',')[0];
                  var day = matchDOB1str.substring(6,7);
                  var month = matchDOB1str.substring(4,5);
                  var year = matchDOB1str.substring(0,3);
                }           
              break;
            
          }
          
          dob = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
           
           ocrRecords.push(recognizedText);
           //console.log('title: ', title);
           results+= '  ...  title: '+ title + ', ';
           ocrRecords.push(title);
           //console.log('first: ', firstname);
           results+= 'firstname: '+ firstname + ', ';
           ocrRecords.push(firstname);
           //console.log('last: ', lastname);
           results+= 'lastname: '+ lastname + ', ';
           //console.log('other: ', otherNames);
           results+= 'otherNames: '+ otherNames + ', ';
           ocrRecords.push(lastname);    
           //console.log('dob: ', dob);    
           results+= 'dob: '+ dob + ', ';
           ocrRecords.push(dob);
           //console.log('medicare: ', Medicare);
           results+= 'Medicare: '+ Medicare + ', ';
           ocrRecords.push(Medicare);
            
           //console.log('3capture_dob: ',this.capture_dob);
           //minumum oktogo - 
           if (
            ((this.capture_firstname==1 && firstname.length>0) || (this.capture_firstname==0))
            &&
            ((this.capture_lastname==1 && lastname.length>0) || (this.capture_lastname==0))
            &&
            ((this.capture_dob==1 && dob.length>0) || (this.capture_dob==0))
           )
           {
            oktogo = true;
           }
         }
         
       } catch (error) {
         console.error('Error capturing photo:', error);
       }
       //return ocrRecords;
       if (oktogo)
       {
        this.presentOcrMatchAlert(ocrRecords);
       }
       else
       {
        this.presentOcrNoMatchAlert(ocrRecords[0]+results);
       }

  }

  async presentOcrMatchAlert(ocrRecords:any[])
  {
    //console.log('ocrRecords: ', ocrRecords);
    let textfound = ocrRecords[0];
    let title = ocrRecords[1];
    let first = ocrRecords[2];
    let last = ocrRecords[3];
    let dob = ocrRecords[4];
    let dobdate = new Date(dob+'T00:00:00'); //add minutes to allow convert to date
    let dobdatestr = moment(dobdate).format('Do MMM yyyy');
    //console.log('d',dobdate);
    //console.log('dstr',dobdatestr);

    const alert = await this.alertController.create({
      cssClass: 'ocrMatchAlert', 
      header: 'Patient Details Found',
      mode:'ios',
      animated: true,
      message: '<div class="patientOcrResults">'+
      /* '<div class="patientOcrFlex">'+
      '<div class="left">Title:</div><div class="right">'+title+'</div>'+
      '</div>'+ */
      '<div class="patientOcrFlex">'+
      '<div class="left">First Name:</div><div class="right">'+first+'</div>'+
      '</div>'+
      '<div class="patientOcrFlex">'+
      '<div class="left">Last Name:</div><div class="right">'+last+'</div>'+
      '</div>'+
      '<div class="patientOcrFlex">'+
      '<div class="left">Date of Birth:</div><div class="right">'+dobdatestr+'</div>'+
      '</div>'+
      '</div>'+
      '<div>Would you like to transfer these values to the patient details?</div>',
      buttons: [
        {
          text: 'Yes',
          cssClass: 'okay',
          role: 'confirm',
          handler: () => { this.pushToPatientForm(ocrRecords); },
        },
        {
          text:'No',
          cssClass: 'cancel',
          role: 'cancel'
        },
        
      ],
    });

    await alert.present();
  }

  async presentOcrNoMatchAlert(textfound:string)
  {

    const alert = await this.alertController.create({
      cssClass: 'ocrMatchAlert', 
      header: 'Not Recognised',
      mode:'ios',
      animated: true,
      message: '<div class="patientOcrResults">Namerow:'+this.name_row+'..  '+
      'Unfortunately we were unable to find patient details from the image provided.  Please make sure the image is of a patient label that clearly shows the patient name and date of birth.  Please make sure the image is of the patient label only with no distracting text or objects outside the bounds of your image.</div>',
      buttons: [        
        {
          text:'OK',
          cssClass: 'cancel',
          role: 'cancel'
        },
        {
          text:'Details',
          cssClass: 'okay',
          role: 'confirm',
          handler: () => { this.showOCRResult(textfound, true); },

        }
      ],
    });

    await alert.present();
  }

  pushToPatientForm(ocrRecords:any[])
  {
    let title = ocrRecords[1];
    let first = ocrRecords[2];
    let last = ocrRecords[3];
    let dob = ocrRecords[4];
    this.advancedForm.controls.patient_first_name.setValue(first);
    this.advancedForm.controls.patient_last_name.setValue(last);
    this.advancedForm.controls.patient_date_of_birth.setValue(dob);
  }

  setLoadingText(text:string) {
    const elem = document.querySelector(
          "div.loading-wrapper div.loading-content");
    if(elem) elem.innerHTML = text;
  }


  async recognizeTextFromImage(imageUrl: string): Promise<string> {

    const loading = await this.loadingCtrl.create({
      message: 'Recognising Patient Details.  Please Wait...',
      mode: 'ios',
    });
    loading.present();

    // Convert base64 image to a Blob
    //const imageBlob = this.base64ToBlob(imageUrl);

    const worker = await createWorker('eng', 1, {
      
      logger: (m) => {
        //console.log(m);
        //console.log('Progress: '+m.progress);
        
        if (m.status == 'recognizing text')
        {
          this.setLoadingText('Scanning... '+Math.floor(m.progress*100)+'%');
        }
        
      }, // Optional logger      
    });

    var whitelist = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz ,:/-0123456789';
    //test
    whitelist = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz ,:/()-0123456789';
  
    await (await worker).load();
    await (await worker).reinitialize('eng');
    await (await worker).setParameters({
      tessedit_char_whitelist: whitelist,
      tessedit_pageseg_mode: PSM.SINGLE_BLOCK,
      preserve_interword_spaces: '1', 
      tessedit_ocr_engine_mode: OEM.LSTM_ONLY
    });

    const { data: { text } } = await (await worker).recognize(imageUrl);
    await (await worker).terminate();
  
    loading.dismiss();

    return text;
  }

  toNameCase(input: string): string {
    return input
    .toLowerCase()
    .replace(/(^\w)|([\s-']\w)/g, match => match.toUpperCase())


  }
  base64ToBlob(base64Data: string): Blob {
    try {
      const decodedImage = atob(base64Data);
      //console.log('Decoded Image:', decodedImage);
      // Rest of the conversion logic
    } catch (err) {
      console.error('Error decoding base64 image:', err);
    }
    const byteString = atob(base64Data);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/jpeg' }); // Modify the type according to your image type
    return blob;
  }

  getHospitalList() {
    this.apiService.post('hospital-list', {}).subscribe(
      (res) => {
        if (res.error === false) {
          this.hospitalList = res.data.hospitals;
          if (this.existingPatient) {
            this.advancedForm.controls.hospital.setValue(
              this.existingPatient.Data.hospital);
          }
        }
      },
      (err) => { }
    );
  }


  getnotificationCount() {
    this.apiService
      .post('user/get-unread-notification-count', {})
      .subscribe(
        (res) => {
          if (res.error === false) {
            this.unreadCount = res.data.unread_notifications;
          }
        },
        (err) => { }
      );
  }

  setCropperOpen(isOpen: boolean) {
    this.isCropperModalOpen = isOpen;
  } 
  
  setPhotoPromptOpen(isOpen: boolean) {
    this.isPhotoPromptModalOpen = isOpen;
  }

  showOCRResult(textfound:string, isOpen: boolean) {
    this.ocrResults = textfound;
    this.isModalOCRDetailOpen = isOpen;
  }
async selectImage() {
  const image = await Camera.getPhoto({
    quality: 100,
    correctOrientation: true,
    source: CameraSource.Photos,
    resultType: CameraResultType.Base64,
  });
  const loading = await this.loadingCtrl.create();
  await loading.present();

  this.myImage = `data:image/jpeg;base64,${image.base64String}`;
  this.imageUrl = this.myImage;
  this.croppedImage = null;
  this.setPhotoPromptOpen(false);
  this.setCropperOpen(true); //open the cropper modal
}

async takeImage() {
  const image = await Camera.getPhoto({
    quality: 100,
    correctOrientation: true,
    source: CameraSource.Camera,
    resultType: CameraResultType.Base64,
  });
  const loading = await this.loadingCtrl.create();
  await loading.present();

  this.myImage = `data:image/jpeg;base64,${image.base64String}`;
  this.imageUrl = this.myImage;
  this.croppedImage = null;
  this.setPhotoPromptOpen(false);
  this.setCropperOpen(true); //open the cropper modal
}
 // Called when cropper is ready
 imageLoaded() {
  this.loadingCtrl.dismiss();
}

// Called when we finished editing (because autoCrop is set to false)
imageCropped(event: ImageCroppedEvent) {
  this.croppedImage = event.base64;
}

// We encountered a problem while loading the image
loadImageFailed() {
  //console.log('Image load failed!');
}

// Manually trigger the crop
cropImage() {
  this.cropper.crop();
  this.imageUrl = this.croppedImage;
  this.myImage = null;
  this.setCropperOpen(false);
}

// Discard all changes
discardChanges() {
  this.myImage = null;
  this.croppedImage = null;
}

// Edit the image
rotatel() {
  const newValue = ((this.transform.rotate ?? 0) - 10) % 360;

  this.transform = {
    ...this.transform,
    rotate: newValue,
  };
}

rotatelfine() {
  const newValue = ((this.transform.rotate ?? 0) - 1) % 360;

  this.transform = {
    ...this.transform,
    rotate: newValue,
  };
}
rotater() {
  const newValue = ((this.transform.rotate ?? 0) + 10) % 360;

  this.transform = {
    ...this.transform,
    rotate: newValue,
  };
}
rotaterfine() {
  const newValue = ((this.transform.rotate ?? 0) + 1) % 360;

  this.transform = {
    ...this.transform,
    rotate: newValue,
  };
}


  //END NG CROPPER CODE

  

  submit(patientData) {
    patientData.fromPatientList = true;
    patientData.newPatientCreated = true;
    const navigationExtras: NavigationExtras = {
      state: patientData
    };
    if (this.existingPatient) {
      //console.log('pp:',navigationExtras)
      return this.navCtrl.navigateBack('patientInfo', navigationExtras);
    }
    return this.navCtrl.navigateForward('patientInfo', navigationExtras);
    //this.navCtrl.navigateForward('/' + this.doctorRole, navigationExtras);
  }

  addPatient() {
    //console.log(this.imageUrl);
    if (!this.imageUrl)
    {    
      this.imageUrl = this.croppedImage;
      
    }
    const imagePayload = [{
      img: this.imageUrl,
      sameId: '',
      fileType: 'image'
    }];
    if (!this.imageUrl.startsWith('https://')) //no change to existing image
    {
      this.advancedForm.controls.images.setValue(imagePayload);
    }
    if (!this.imageUrl || this.imageUrl === environment.imgBaseUrl) {
      return this.presentAlertConfirm();
    }

    this.submitted = true;
    if (this.advancedForm.valid) {
      this.advancedForm.controls.ref_doctor.setValue(
        this.advancedForm.controls.ref_doctorF.value + " " + this.advancedForm.controls.ref_doctorL.value
      );

      this.advancedForm.controls.patient_date_of_birth.setValue(
        moment(this.advancedForm.controls.patient_date_of_birth.value).format(
          'YYYY-MM-DD'
        )
      );
      this.advancedForm.controls.referral_date.setValue(
        moment(this.advancedForm.controls.referral_date.value).format(
          'YYYY-MM-DD'
        )
      );

      this.advancedForm.controls.User.setValue(this.user);
      this.advancedForm.controls.billType.setValue(this.doctorRole);
      this.loading = true;

      this.apiService.post('add_patient', this.advancedForm.value).subscribe(
        (res) => {
          this.loading = false;
          if (res.error === false) {
            let smessage = 'Patient Added Successfully';
            if (this.existingPatient)
            {
              smessage = 'Patient Updated Successfully';
            }
            this.toastService.presentToast(
              'success',
              smessage
            );
            this.submit(res.data.submission);
            if (res.data.submission) {
              this.advancedForm.controls.editing.setValue(res.data.submission.Data.id);
            }

            // this.advancedForm.reset();
          }
        },
        (err) => {
          this.submitted = false;
        }
      );
    } else {
      for (const property in this.advancedForm.value) {
        this.advancedForm.controls[property].markAsTouched();
      }
    }

  }


  async presentAlertConfirm() {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Patient Sticker',
      message: 'You must add a Patient sticker before you can submit billing.',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
          },
        },
        {
          text: 'Add Sticker',
          handler: () => {
            this.setPhotoPromptOpen(true);
          },
        },
      ],
    });

    await alert.present();
  }

  presentModal() {
    this.modalController.create({
      component: DoctorsListComponent,
      // cssClass: 'billing-modal',
      showBackdrop: true,
      backdropDismiss: true
    }).then(res => {
      res.present();
      res.onDidDismiss().then((doctor: any) => {
        if (doctor && doctor.data) {
          this.advancedForm.controls.ref_doctor.setValue(doctor.data);
        }
      });
    });
  }

  ionViewWillLeave() {
    this.events.destroy('PatientInfoEvent');
  }
  updateDOB($event) {
    this.patient_dateofbirth = $event.detail.value;
  }
  updateReferralDate($event) {
    this.patient_referraldate = $event.detail.value;
  }
  clearDoctor() {
    this.advancedForm.controls.ref_doctor.setValue("");
  }

}
